import script from "./AddDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDocument.vue?vue&type=script&setup=true&lang=js"

import "./AddDocument.vue?vue&type=style&index=0&id=82f83940&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82f83940"]])

export default __exports__